import './index.css'
import { useEffect, useState } from "react"
import Copyright from "../common/Copyright"
import SimpleSelection from "../common/SimpleSelection"
import MainContainer from "../common/MainContainer"
import CustomFieldsListing from "./CustomFieldsListing"
import useUser from "../../hooks/useUser"
import { useProject } from "../../context/ProjectContext"
import AddChip from "../common/ActionChip/AddChip"
import { itemSelection } from "../../models/itemSelection.model"


interface ProjectSettingsProps {
  setBlockScreen: (p: boolean) => void
}

const ProjectSettings: React.FC<ProjectSettingsProps> = ({
  setBlockScreen,
}) => {

  const { userAdmin }: any = useUser()
  const { selectedProject } = useProject()

  const options: itemSelection[] = [
    { 'id': 'custom_fields', 'label': 'Campos Personalizados' },
  ]

  const defaultSection = { 'section': options[0] ?? { id: '', label: '' } }
  const [sectionSelected, setSectionSelected] = useState(defaultSection)

  const [openActionModal, setOpenActionModal] = useState(false)
  const [action, setAction] = useState<'view' | 'edit' | 'create'>('view')

  const handleChange = (event: React.ChangeEvent<HTMLInputElement> | { 'target': { 'name': any, 'value': any } }): void => {
    setSectionSelected({
      ...sectionSelected,
      [event.target.name]: event.target.value
    });
  }

  const initComponent = () => {
    setBlockScreen(true)
    setBlockScreen(false)
  }

  useEffect(initComponent, [])

  return (
    <>
      <MainContainer>
        <div className="projectsettings-actions-bar">
          <span className="projectsettings-actions-bar-selector">
            <SimpleSelection
              label="Configuración"
              options={options}
              name={"section"}
              value={sectionSelected.section}
              onChange={handleChange}
            />
          </span>
          {selectedProject && (sectionSelected.section.id == 'custom_fields') && (
            <span className="projectsettings-actions-bar-add-btn">
              <AddChip
                onClick={() => { setAction('create'); setOpenActionModal(true) }}
                label='Nuevo Campo Personalizado'
              />
            </span>
          )}
        </div>

        {sectionSelected.section.id == 'custom_fields' && (
          <CustomFieldsListing
            openActionModal={openActionModal}
            setOpenActionModal={setOpenActionModal}
            action={action}
            setAction={setAction}
            canEdit={userAdmin}
            setBlockScreen={setBlockScreen}
            project_id={selectedProject}
          />
        )}
      </MainContainer>
      <Copyright marginBottom={'1rem'} />
    </>
  );
}

export default ProjectSettings;